import noop from '../utils/noop';

export default {
  onLoad: noop,
  onError: noop,
};
